import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n, setLocale } from 'react-redux-i18n'

import { Modal, Form, Input, Button, Spin, Select, message, Switch,Space,InputNumber } from 'antd'
import { MinusCircleOutlined, EditOutlined, PlusOutlined, AppstoreAddOutlined } from '@ant-design/icons';

import * as ToolRequest from '../../tools/ToolRequest'
import SpinFull from '../../components/SpinFull'

const formLayout = {
  labelCol: {
    md: {span: 5},
    sm: {span: 24},
  },
  wrapperCol: {
    md: {span: 16},
  },
}

const formTailLayout = {
  wrapperCol: {
    md: {offset: 5, span: 16},
  },
}

export default function UserEditModal (props) {
  const {userId,visible, onOk, onCancel} = props
  const [loaded, setLoaded] = useState(false)
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState(null)

  useEffect(() => {
    (async () => {
      try {
        const userRes = await ToolRequest.request('GET', `/user/${userId}`)
        setUser(userRes.data)
      } catch (e) {
        message.error(e)
      }
      setLoaded(true)
    })()
  }, [])

  const onFinish = async (values) => {
    setLoading(true)
    try {
      const data = {
        name:values.name,
        fullName:values.fullName,
        email:values.email,
        isEnabled:values.isEnabled,
      }
      await ToolRequest.request('PUT', `/user/${userId}`, data)
      message.success(I18n.t('editSuccessMessage'))
      onOk()
      setLoading(false)
    } catch (err) {
      console.dir(err)
      setLoading(false)
      if (err?.response?.data) {
        switch (err.response.data) {
          default:
            return message.error(I18n.t('errorMessageUnknownError'))
        }
      }

      message.error(I18n.t('errorMessageUnknownError'))
    }
  }

  return (
    <Modal
      title={I18n.t('編輯用戶')}
      visible={visible}
      onCancel={onCancel}
      width="50%"
      maskClosable={false}
      footer={null}
    >
      {loaded ? (
        <Spin spinning={loading}>
          <Form
            {...formLayout}
            initialValues={user}
            onFinish={onFinish}
          >
            <Form.Item
                label={I18n.t('郵箱')}
                name="email"
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: I18n.t('errorMessageRequiredInputAny', {
                      name: `${I18n.t('郵箱')}`,
                    }),
                  },
                ]}
            >
              <Input
                  placeholder={I18n.t('郵箱')}
              />
            </Form.Item>
            <Form.Item
                label={I18n.t('POS登錄名')}
                name="name"
            >
              <Input
                  placeholder={I18n.t('POS登錄名')}
              />
            </Form.Item>
            <Form.Item
              label={I18n.t('全名')}
              name="fullName"
            >
              <Input
                placeholder={I18n.t('全名')}
              />
            </Form.Item>
            <Form.Item
                label="啟用"
                name="isEnabled"
                valuePropName="checked"
            >
              <Switch defaultChecked={true}/>
            </Form.Item>
            <Form.Item {...formTailLayout}>
              <Button type="primary" htmlType="submit" block>
                {I18n.t('提交')}
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      ) : <SpinFull/>}
    </Modal>
  )
};